import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="toggle"
export default class extends Controller {
  static values = { state: Boolean };

  stateValueChanged(val) {
    this.dispatch(val ? 'set' : 'unset');
  }

  toggle() {
    this.stateValue = !this.stateValue;
  }

  unset() {
    this.stateValue = false;
  }

  set() {
    this.stateValue = true;
  }
}
